import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { Button_s, Label_s} from 'styles/app-styles'

const OverageInherit = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.overagedetail"));

  const emptyRecord = {}

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'inherit') setData(emptyRecord)
  }, [props['rowData']])

  function updateData():void {
    let nextData:object

    nextData = {
      state: 'inherit',
      overage: 'Inherit'
    }

    setData(nextData);
    props.persist(nextData, 'overagedetail', props.rowData)
  }

  const isInherit = _.get(data, 'state') == 'inherit'

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          { isInherit
            ? <Label_s>Inherit Selected</Label_s>
            : <Button_s className="rounded btn" onClick={() => updateData()}>Select Inherit</Button_s>
          }
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default OverageInherit
